import React from 'react'

import ProfileSecurity from './ProfileSecurity'
import AccountSecurity from './AccountSecurity'

const Security = () => {
  return (
    <div className="pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Security Settings
      </h3>

      <ProfileSecurity />

      <AccountSecurity />
    </div>
  )
}

export default Security
